import React from "react";
import { faCircle } from "@fortawesome/pro-regular-svg-icons";
import { faCircleDot } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var RadioButton = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, checked = _a.checked, onChange = _a.onChange, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    var handleClick = function () {
        if (!disabled) {
            onChange(value);
        }
    };
    // Determine the icon to display
    var getIcon = function () {
        return checked ? faCircleDot : faCircle;
    };
    return (React.createElement("div", { className: "lib-radio-wrapper ".concat(disabled ? "lib-radio-disabled" : "", " ").concat(className), onClick: handleClick },
        React.createElement("div", { className: "lib-radio-icon" },
            React.createElement(FontAwesomeIcon, { icon: getIcon(), className: checked ? "lib-radio-checked" : "lib-radio-unchecked" })),
        label && React.createElement("span", { className: "lib-radio-label" }, label),
        React.createElement("input", { id: id, name: name, type: "radio", value: value, checked: checked, onChange: function () { }, disabled: disabled, style: { display: "none" } })));
};
export default RadioButton;
